import React, { useEffect, useState } from 'react';

import Table from '~components/molecules/Table';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './_GoldConversionTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import UtilFunctions from '~utils/functions';
import { GoldConversionStatusEnum } from '~utils/enums';
import Chip from '~components/atoms/Chip';
import combinedActions from '~redux/combinedActions';

const GoldConversionTable = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const goldConversionListing = useAppSelector(state => state.gold.goldConversion.data);

    const goldConversionListingIndex = useAppSelector(state => state.gold.goldConversion.index);
    const isLoading = useAppSelector(state => state.gold.loadings.getGoldConversionListing);
    const isError = useAppSelector(state => state.gold.errors.getGoldConversionListing);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetGoldConversionListingAttempt());
    }, [goldConversionListingIndex]);

    const tableHeader = [
        'TRANSACTION ID',
        'TRANSACTION TYPE',
        'AMOUNT',
        'PRODUCT CONVERTED',
        'SERIAL NUMBER',
        'CUSTOMER NAME',
        'CIF NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'STATUS',
        'BRANCH TELLER NAME',
        'SALES PERSONNEL NAME',
        'REFERRAL NAME',
        'TRANSACTION DATE',
        'ACTION',
    ];

    const tableBody = goldConversionListing.map(conversion => {
        const {
            conversionId,
            amount,
            targetProductName,
            serialNo,
            customerName,
            CIFNo,
            branchCode,
            branchName,
            regionName,
            status,
            branchTellerName,
            salesPersonnelName,
            referralName,
            createdAt,
        } = conversion;

        const handleViewSerialNo = () => {
            if (!serialNo) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            if (!serialNo) return '-';

            return (
                <ActionButton
                    key={conversionId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderStatusChip = (statusValue: GoldConversionStatusEnum, label: string) => {
            switch (statusValue) {
                case GoldConversionStatusEnum.Pending: {
                    return (
                        <Chip
                            type='warning'
                            label={label}
                        />
                    );
                }

                case GoldConversionStatusEnum.Approved: {
                    return (
                        <Chip
                            type='inactive'
                            label={label}
                        />
                    );
                }

                case GoldConversionStatusEnum.Rejected: {
                    return (
                        <Chip
                            type='inactive'
                            label={label}
                        />
                    );
                }

                default: return <Chip label={label} />;
            }
        };

        return [
            conversionId,
            'Gold Conversion',
            amount,
            targetProductName,
            renderSerialNo(),
            customerName,
            CIFNo,
            branchCode,
            branchName,
            regionName,
            renderStatusChip(status, GoldConversionStatusEnum[status]),
            branchTellerName || '-',
            salesPersonnelName || '-',
            referralName || '-',
            dateTimeFormat(createdAt),
            '-',
        ];
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

        </>

    );
};

export default GoldConversionTable;
